import type { BreadcrumbProps } from '@meterup/atto';
import { matchPath } from 'react-router';

import { paths } from '../constants';
import { makeLink } from './main_and_drawer_navigation';

/**
 * Don't use this in a tight loop, it iterates over all known paths.
 */
export function getNextBestCurrentPathForNetwork({
  companyName,
  networkSlug,
  crumbs,
  currentPathname,
}: {
  companyName: string;
  networkSlug: string;
  crumbs: BreadcrumbProps[] | null | undefined;
  /**
   * If undefined, skips checking for current path.
   */
  currentPathname: string | undefined;
}): string {
  // This is very hacky but maybe okay?
  if (currentPathname) {
    for (const path of Object.values(paths.pages)) {
      const match = matchPath(
        {
          path,
        },
        currentPathname,
      );

      const params = match?.params ?? {};
      const matchedParams = Object.values(params);

      if (!('companyName' in params) || !('networkSlug' in params)) {
        continue;
      }

      if (matchedParams.length === 2) {
        return makeLink(path, {
          companyName,
          networkSlug,
        });
      }

      if (matchedParams.length === 3 && ('tab' in params || 'activeTab' in params)) {
        return makeLink(path, {
          ...params,
          companyName,
          networkSlug,
        });
      }
    }
  }

  if (crumbs) {
    for (const crumb of crumbs.toReversed()) {
      if (!crumb?.page?.path || !crumb?.page.to) continue;
      const match = matchPath(
        {
          path: crumb.page.path,
        },
        crumb.page.to,
      );

      const params = match?.params ?? {};
      const matchedParams = Object.values(params);

      if (!('companyName' in params) || !('networkSlug' in params)) {
        continue;
      }

      if (matchedParams.length === 2) {
        return makeLink(crumb.page.path, {
          companyName,
          networkSlug,
        });
      }

      if (matchedParams.length === 3 && ('tab' in params || 'activeTab' in params)) {
        return makeLink(crumb.page.path, {
          ...params,
          companyName,
          networkSlug,
        });
      }
    }
  }

  return makeLink(paths.pages.IndividualNetworkRootPage, {
    companyName,
    networkSlug,
  });
}
